export const DEVELOPER_PROJ_STATUS = {
  Inactive: 0,
  Pending_Release: 1, 
  Active: 2,
  Suspended: 3,
  Expired: 4
}

export const DeveloperProjectStatusString = {
  [DEVELOPER_PROJ_STATUS.Inactive]: "Inactive",
  [DEVELOPER_PROJ_STATUS.Pending_Release]: "Pending Release",
  [DEVELOPER_PROJ_STATUS.Active]: "Active",
  [DEVELOPER_PROJ_STATUS.Suspended]: "Suspended",
  [DEVELOPER_PROJ_STATUS.Expired]: "Expired"
};
